import { logUserDataResponseError } from './processResponse';
import {
    UserDataInfo,
    UserDataInfoProperty,
    UserDataStoreItem,
} from '../data/schema/UserDataStoreSchema';
import { format } from 'owa-localize';
import { makeGetRequest } from 'owa-ows-gateway';

const GET_USER_DATA_COLLECTION_NAME = 'GetUserDataCollection';
const GET_USER_DATA_BY_CATEGORY_NAME = 'GetUserDataByCategory';
const USER_DATA_GET_COLLECTION_URL: string = 'ows/v1.5/UserDataStore/items';
const USER_DATA_GET_BY_CATEGORY_URL: string = 'ows/v1.5/UserDataStore/items?category={0}';

/**
 * Retrieve the UserData collection for the current user, it should contains all
 * the stored info for the user.
 */
export async function getUserDataCollectionService(): Promise<UserDataStoreItem[]> {
    try {
        const response = await makeGetRequest(USER_DATA_GET_COLLECTION_URL);
        return Promise.resolve(response.category ? [convertResponseToUserDataItem(response)] : []);
    } catch (error) {
        logUserDataResponseError(GET_USER_DATA_COLLECTION_NAME, error?.message);
        return Promise.resolve(null);
    }
}

/**
 * Retrieve the UserDataInfo for the current user under the provided category.
 */
export async function getUserDataByCategoryService(category: string): Promise<UserDataStoreItem> {
    try {
        const response = await makeGetRequest(format(USER_DATA_GET_BY_CATEGORY_URL, category));
        return Promise.resolve(
            response.category
                ? convertResponseToUserDataItem(response)
                : <UserDataStoreItem>{ category: category, userDataInfos: [] }
        );
    } catch (error) {
        logUserDataResponseError(GET_USER_DATA_BY_CATEGORY_NAME, error?.message);
        return Promise.resolve(null);
    }
}

function convertResponseToUserDataItem(response: any): UserDataStoreItem {
    return <UserDataStoreItem>{
        category: response.category,
        userDataInfos: response.quickUseInfoList.map(
            userData =>
                <UserDataInfo>{
                    key: userData.key,
                    value: userData.value,
                    contentType: userData.contentType,
                    dataSource: userData.dataSource,
                    additionalProp: <UserDataInfoProperty>{
                        creationTimeUTC: userData.createdDateTimeUTC,
                        lastModifiedTimeUTC: userData.updatedDateTimeUTC,
                        isPinned: userData.isPinned,
                    },
                }
        ),
    };
}
